export default "__VITE_ASSET__HvnqSKHy__"